export const INCREASE_COUNTER = '@@example/INCREASE_COUNTER';
export const DECREASE_COUNTER = '@@example/DECREASE_COUNTER';
export const SET_COUNTER = '@@example/SET_COUNTER';
export const CLEAR_COUNTER = '@@example/CLEAR_COUNTER';
